// FTEDN Creator — Leaderboard component
import { useState } from 'react';
import { buildLeaderboard, type LeaderboardEntry } from './community.helpers';
import { useUserStore } from '../../stores/user.store';
import './CommunityPage.css';

type SortBy = 'xp' | 'streak' | 'reviews';

// Mock leaderboard data until we have a dedicated API endpoint
const MOCK_USERS = [
  { name: 'GlowGetter', xp: 8400, level: 17, streak: 22, reviewCount: 18 },
  { name: 'SkinScience', xp: 6200, level: 13, streak: 15, reviewCount: 12 },
  { name: 'BeautyLab', xp: 5800, level: 12, streak: 8, reviewCount: 21 },
  { name: 'NaturalVibes', xp: 4100, level: 9, streak: 31, reviewCount: 7 },
  { name: 'CleanBeautyFan', xp: 3900, level: 8, streak: 12, reviewCount: 14 },
  { name: 'HairGoals', xp: 3200, level: 7, streak: 5, reviewCount: 9 },
  { name: 'RoutineQueen', xp: 2800, level: 6, streak: 18, reviewCount: 6 },
  { name: 'SkincareDaily', xp: 2100, level: 5, streak: 3, reviewCount: 11 },
];

const MEDALS = ['🥇', '🥈', '🥉'];

export function Leaderboard() {
  const [sortBy, setSortBy] = useState<SortBy>('xp');
  const { profile } = useUserStore();

  // Include current user if we have profile data
  const allUsers = profile
    ? [...MOCK_USERS, { name: profile.displayName, xp: profile.xp, level: profile.level, streak: profile.streak, reviewCount: profile.reviewCount }]
    : MOCK_USERS;

  const entries = buildLeaderboard(allUsers, sortBy, 10);

  return (
    <div className="leaderboard">
      <div className="leaderboard-header">
        <h2>🏆 Top Eeduners</h2>
        <div className="leaderboard-sort">
          <button className={`sort-btn ${sortBy === 'xp' ? 'active' : ''}`} onClick={() => setSortBy('xp')}>⚡ XP</button>
          <button className={`sort-btn ${sortBy === 'streak' ? 'active' : ''}`} onClick={() => setSortBy('streak')}>🔥 Streak</button>
          <button className={`sort-btn ${sortBy === 'reviews' ? 'active' : ''}`} onClick={() => setSortBy('reviews')}>⭐ Reviews</button>
        </div>
      </div>

      <div className="leaderboard-list">
        {entries.map(entry => {
          const isMe = profile?.displayName === entry.name;
          return (
            <div key={entry.rank} className={`leaderboard-row ${isMe ? 'leaderboard-me' : ''}`}>
              <span className="lb-rank">
                {entry.rank <= 3 ? MEDALS[entry.rank - 1] : `#${entry.rank}`}
              </span>
              <div className="lb-user">
                <span className="lb-name">{entry.name}{isMe ? ' (you)' : ''}</span>
                <span className="lb-level">Lv.{entry.level}</span>
              </div>
              <span className="lb-value">
                {sortBy === 'xp' && `${entry.xp.toLocaleString()} XP`}
                {sortBy === 'streak' && `${entry.streak}d 🔥`}
                {sortBy === 'reviews' && `${entry.reviewCount} ⭐`}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
